import React, {useState} from 'react'
import Breadcrumb, {BreadcrumbType} from '../../components/Breadcrumb'
import {
  AssetsBox,
  AssetTitle,
  IconsBox,
  LeftBox,
  RightBox,
  TimeBox,
} from '../VideoPage/styles'
import {getDivisionDetails} from '../../../constants/divisions'
import {useSelector} from 'react-redux'
import Loading from '../../../components/Loading'
import {LoadingStatuses} from '../../../components/types/LoadingStatusses'
import {useWindowDimensions} from '../../../hooks/useWindowDimensions'
import {Course, selectCourseStatus} from '../../../redux/courses'
import {VideoGroup} from '../../../redux/videos'
import LessonPlanSidenav from '../../components/LessonPlanSidenav'
import {Helmet} from 'react-helmet'
import QuizQuestions from '../../../components/QuizQuestions'
import {QuizBox} from '../QuizPage/styles'

type Props = {
  course: Course
  examId: string
  videoGroup?: VideoGroup[]
  currentQuestion: number
  attemptStarted: boolean
  onChangeCurrentQuestion: (value: number) => void
  onChangeAttemptStarted: (value: boolean) => void
}

const View = ({
  course,
  examId,
  videoGroup,
  currentQuestion,
  attemptStarted,
  onChangeCurrentQuestion,
  onChangeAttemptStarted,
}: Props) => {
  const {isMobile} = useWindowDimensions()

  const [isExpanded, setIsExpanded] = useState(isMobile ? false : true)
  const courseStatus = useSelector(selectCourseStatus)

  const filteredGroup = videoGroup
    ?.map((group, index) => {
      const found = group.lessons.some(lesson => lesson.id === examId)

      return found ? {group, index} : null
    })
    .filter(item => item !== null)[0]

  const currentGroup = filteredGroup?.group

  const nextGroup =
    videoGroup && videoGroup[filteredGroup?.index! + 1]
      ? videoGroup[filteredGroup?.index! + 1]
      : undefined

  const currentIndex = currentGroup?.lessons.findIndex(
    lesson => lesson.id === examId,
  )

  const currentQuiz = currentGroup?.lessons[currentIndex!]

  const getNextUrl = () => {
    const nextLesson = currentGroup?.lessons[currentIndex! + 1]
    if (nextLesson) {
      return `/courses/${currentGroup?.courseId}/${
        nextLesson.assetTypeAbbr
      }/${nextLesson?.id}${nextLesson?.isFree ? '/free' : ''}`
    } else if (nextGroup) {
      return `/courses/${currentGroup?.courseId}/${nextGroup?.lessons[0]
        .assetTypeAbbr}/${nextGroup?.lessons[0].id}${
        nextGroup?.lessons[0]?.isFree ? '/free' : ''
      }`
    } else {
      return '/'
    }
  }

  const isSectionQuiz = currentQuiz?.shortDescription.includes('Section')

  const breadcrumbs: BreadcrumbType[] = [
    {
      title: course?.title ?? '',
      url: `/courses/${course?.id}`,
    },
    {
      title: currentQuiz?.shortDescription ?? '',
      url: `#`,
    },
  ]

  const division = getDivisionDetails(course?.abbreviation)

  return (
    <>
      <Helmet>
        {currentQuiz && (
          <title>{`${currentQuiz.shortDescription} | Black Spectacles`}</title>
        )}
      </Helmet>
      {!isMobile && <Breadcrumb breadcrumbs={breadcrumbs} />}
      <AssetsBox>
        {!isSectionQuiz && currentQuiz && (
          <LeftBox $isExpanded={isExpanded}>
            <LessonPlanSidenav
              id={examId}
              course={course}
              currentGroup={currentGroup}
              isExpanded={isExpanded}
              onChangeIsExpanded={(value: boolean) => setIsExpanded(value)}
            />
          </LeftBox>
        )}
        <RightBox>
          {courseStatus === LoadingStatuses.Loading ||
          courseStatus === LoadingStatuses.Idle ? (
            <Loading />
          ) : (
            <>
              <IconsBox>
                <img src={division?.icon} alt={division?.name} />
                <AssetTitle style={{marginTop: 0}}>
                  {currentQuiz?.shortDescription}
                </AssetTitle>
              </IconsBox>
              {attemptStarted &&
              currentQuestion < (currentQuiz?.questions ?? 0) ? (
                <TimeBox>
                  Question {currentQuestion + 1} of {currentQuiz?.questions}
                </TimeBox>
              ) : (
                <TimeBox>{currentQuiz?.questions} questions</TimeBox>
              )}

              <QuizBox>
                <QuizQuestions
                  lesson={currentQuiz}
                  currentQuestion={currentQuestion}
                  setCurrentQuestion={onChangeCurrentQuestion}
                  setAttemptStarted={onChangeAttemptStarted}
                  getNextUrl={getNextUrl}
                  quizId={examId}
                />
              </QuizBox>
            </>
          )}
        </RightBox>
      </AssetsBox>
    </>
  )
}

export default View
